import { render, staticRenderFns } from "./Prestore.vue?vue&type=template&id=90d1e872&scoped=true&"
import script from "./Prestore.vue?vue&type=script&lang=js&"
export * from "./Prestore.vue?vue&type=script&lang=js&"
import style0 from "./Prestore.vue?vue&type=style&index=0&id=90d1e872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d1e872",
  null
  
)

/* custom blocks */
import block0 from "./Prestore.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports